<template>

    <v-container fluid>



        <v-form ref="form" v-model="valid" lazy-validation>

            <v-card-text>

                <v-row>

                    <v-col cols="12 mb-11 ml-n6">

                        <v-stepper backgroud v-model="step">
                            <v-stepper-header>
                                <v-stepper-step :complete="step > 1" step="1" @click="AlterarPasso(1)">
                                    CNPJ e Razão
                                    Social
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="step > 2" step="2" @click="AlterarPasso(2)">
                                    Dados do
                                    Corretor
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="step > 3" step="3" @click="AlterarPasso(3)">
                                    Informações
                                    Gerais
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="step > 4" step="4" @click="AlterarPasso(4)">
                                    Usuário Master
                                    Portal
                                    EZZE
                                </v-stepper-step>

                            </v-stepper-header>
                        </v-stepper>

                    </v-col>
                </v-row>

                <v-row id="etapa1" v-show="step == 1">
                    <v-col cols="12" sm="12" md="6" lg="6" class="mt-n9">
                        <v-text-field :rules="[rules.required, rules.validarCnpj]" label="CNPJ" @blur="PesquisarCNPJ()"
                                      :loading="loadingCnpj" v-mask="['##.###.###/####-##']" color="#007681"
                                      v-model="cnpj"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="6" class="mt-n9">
                        <v-text-field :readonly="true" label="NÚMERO SUSEP" v-mask="['###########']" color="#007681"
                                      v-model="numeroSusep"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" lg="12" class="mt-n8">
                        <v-text-field :readonly="true" label="RAZÃO SOCIAL" style="color:black !important"
                                      color="#007681" maxlength="100" v-model="razaoSocial"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="2" lg="2" class="mt-n8">
                        <v-text-field :rules="[rules.required]" @input="BuscarCep" label="CEP" v-mask="['#####-###']"
                                      color="#007681" v-model="cep"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="5" lg="5" class="mt-n8">
                        <v-text-field :rules="[rules.required]" label="LOGRADOURO" color="#007681" maxlength="100"
                                      v-model="logradouro"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="1" lg="1" class="mt-n8">
                        <v-text-field :rules="[rules.required]" label="Nº" v-mask="['########']" color="#007681"
                                      v-model="numero"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n8">
                        <v-text-field label="COMPLEMENTO" color="#007681" maxlength="80"
                                      v-model="complemento"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="3" lg="3" class="mt-n8">
                        <v-text-field :rules="[rules.required]" label="BAIRRO" maxlength="40" color="#007681"
                                      v-model="bairro"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="9" lg="9" class="mt-n8" id="col-Assessoria">

                        <v-autocomplete color="#007681" :rules="[rules.required]" v-model="cidade" :loading="loading"
                                        :items="cidades" :search-input.sync="search" :cache-items=true label="CIDADE"
                                        item-text="nomeCidade" item-value="idCidade" hide-no-data hide-selected clearable
                                        return-object></v-autocomplete>

                    </v-col>

                    <v-col cols="12" sm="12" md="5" lg="5" class=" align-md-center">
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class=" align-md-center">
                        <v-btn :loading="loadingBtn" block color="#303030" @click="AlterarPasso(2)" dark>
                            PRÓXIMA
                            ETAPA
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="5" class=" align-md-center">
                    </v-col>
                </v-row>

                <v-row id="etapa2" v-show="step == 2">

                    <v-col cols="12" class="mt-n1">
                        <h4>ASSESSORIA</h4>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" lg="12" class="mt-n5">
                        <template v-slot:label>
                            <div>Possui Assessoria?</div>
                        </template>
                        <v-radio-group v-model="possuiAssessoria" row :rules="[rules.required]"
                                       v-on:change="PossuiAssessoria">
                            <template v-slot:label>
                                <div>Possui Assessoria?</div>
                            </template>

                            <v-radio label="Sim" value="true"></v-radio>

                            <v-radio label="Não" value="false"></v-radio>

                        </v-radio-group>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="6" class="mt-n5" v-show="assessoriaShow">
                        <v-autocomplete color="#007681" :rules="(possuiAssessoria == [true]) ? [rules.required] : []"
                                        v-model="assessoria" :loading="loadingAssessoria" :items="assessoriaItem"
                                        :search-input.sync="searchAssessoria" :cache-items=true label="Assessoria"
                                        placeholder="Digite o nome da assessoria" item-text="nm_pessoa" item-value="id_pessoa"
                                        hide-no-data hide-selected clearable return-object></v-autocomplete>
                    </v-col>

                    <v-col cols="12" class="mt-n1">
                        <h4>DADOS BANCARIOS</h4>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5">
                        <v-autocomplete :rules="[rules.required]" item-text="nm_banco" item-value="nr_banco" :items="bancosjson"
                                        label="BANCO" return-object color="#007681" v-model="banco" item-props="true"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5">
                        <v-text-field :rules="[rules.required]" label="AGÊNCIA/DÍGITO" v-mask="['#########']"
                                      color="#007681" v-model="agenciaDigito"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5">
                        <v-text-field :rules="[rules.required]" label="CONTA/DÍGITO" v-mask="['#########']"
                                      color="#007681" v-model="contaDigito"></v-text-field>
                    </v-col>

                    <v-col cols="12" class="mt-n8">

                        <v-checkbox v-model="checkbox" label="Utilizar o mesmo endereço para cobrança?" color="#007681"
                                    @change="UtilizarMesmoEndereco()" @blur="UtilizarMesmoEndereco()"></v-checkbox>


                    </v-col>

                    <v-col cols="12" sm="12" md="2" lg="2" class="mt-n8">
                        <v-text-field :rules="[rules.required]" @input="BuscarCepCobranca"
                                      v-on:change="BuscarCepCobranca" label="CEP" v-mask="['#####-###']" color="#007681"
                                      v-model="cepCobranca"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="5" lg="5" class="mt-n8">
                        <v-text-field :rules="[rules.required]" label="LOGRADOURO" color="#007681" maxlength="100"
                                      v-model="logradouroCobranca"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="1" lg="1" class="mt-n8">
                        <v-text-field :rules="[rules.required]" label="Nº" v-mask="['########']" color="#007681"
                                      v-model="numeroCobranca"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n8">
                        <v-text-field label="COMPLEMENTO" color="#007681" maxlength="80"
                                      v-model="complementoCobranca"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="3" lg="3" class="mt-n8">
                        <v-text-field :rules="[rules.required]" label="BAIRRO" maxlength="40" color="#007681"
                                      v-model="bairroCobranca"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="9" lg="9" class="mt-n8">

                        <v-autocomplete color="#007681" :rules="[rules.required]" v-model="cidadeCobranca"
                                        :loading="loadingCobranca" :items="cidadesCobranca" :search-input.sync="searchCobranca"
                                        :cache-items=true label="CIDADE" item-text="nomeCidade" item-value="idCidade" hide-no-data
                                        hide-selected clearable return-object></v-autocomplete>

                    </v-col>

                    <v-col cols="12" class="mt-n1">
                        <h4>CONTATOS</h4>
                    </v-col>

                    <v-container v-for="item in contatos" :key="item.id" max-width="100%">
                        <v-row>
                            <v-col cols="12" sm="12" md="6" lg="6" class="mt-n5">
                                <v-text-field :rules="[rules.required]" label="NOME" maxlength="75" color="#007681"
                                              v-model="item.nome"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="6" lg="6" class="mt-n5">
                                <v-text-field label="E-MAIL" :rules="[rules.required, rules.email]" maxlength="75"
                                              color="#007681" v-model="item.email"></v-text-field>
                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="6" lg="6" class="mt-n5">
                                <v-text-field :rules="[rules.required]" label="TELEFONE" color="#007681"
                                              v-model="item.telefone" v-mask="(item.telefone.length >= 15) ? ['(##) #####-####'] : ['(##) ####-####']"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="6" lg="6" class="mt-n5">
                                <v-text-field label="CARGO" :rules="[rules.required]" maxlength="75" color="#007681"
                                              v-model="item.cargo"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                        <v-btn block color="#303030" @click="AdicionarContato()" dark>ADICIONAR NOVO CONTATO</v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                    </v-col>

                    <v-col cols="12" class="mt-n1">
                        <h4>GRUPO DE CORRETOR</h4>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" lg="12" class="mt-n5">
                        <template v-slot:label>
                            <div>Possui Grupo de Corretor?</div>
                        </template>
                        <v-radio-group v-model="possuiGrupoCorretor" row :rules="[rules.required]">
                            <template v-slot:label>
                                <div>Possui Grupo de Corretor?</div>
                            </template>

                            <v-radio label="Sim" value="true"></v-radio>

                            <v-radio label="Não" value="false"></v-radio>

                        </v-radio-group>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" lg="12" class="mt-n5" v-show="possuiGrupoCorretor == [true]">
                        <template v-slot:label>
                            <div>Corretor Líder?</div>
                        </template>
                        <v-radio-group v-model="corretorLider" row
                                       :rules="(possuiGrupoCorretor == [true]) ? [rules.required] : []">
                            <template v-slot:label>
                                <div>Corretor Líder?</div>
                            </template>

                            <v-radio label="Sim" value="true"></v-radio>

                            <v-radio label="Não" value="false"></v-radio>

                        </v-radio-group>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="6" class="mt-n5"
                           v-show="corretorLider == [false] && possuiGrupoCorretor == [true]">
                        <v-text-field :rules="(corretorLider == [false] && possuiGrupoCorretor == [true]) ? [rules.required, rules.validarCnpj] : []" label="CNPJ CORRETORA LÍDER"
                                      @blur="PesquisarCNPJCorretoraLider()" :loading="loadingCnpjCorretorLider"
                                      v-mask="['##.###.###/####-##']" color="#007681" v-model="cnpjCorretorLider"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="6" class="mt-n5"
                           v-show="corretorLider == [false] && possuiGrupoCorretor == [true]">
                        <v-text-field :readonly="true" label="RAZÃO SOCIAL CORRETORA LÍDER"
                                      style="color:black !important" color="#007681" maxlength="100"
                                      v-model="razaoSocialCorretorLider"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class=" align-md-center">
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class=" align-md-center">
                        <v-btn :loading="loadingBtn" block color="#303030" @click="AlterarPasso(1)" dark>
                            VOLTAR
                            ETAPA
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class=" align-md-center">
                        <v-btn :loading="loadingBtn" block color="#303030" @click="AlterarPasso(3)" dark>
                            PRÓXIMA
                            ETAPA
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class=" align-md-center">
                    </v-col>
                </v-row>

                <v-row id="etapa3" v-show="step == 3">
                    <v-col cols="12" class="mt-n1">
                        <h4>INFORMAÇÕES GERAIS</h4>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5">
                        <v-autocomplete item-text="valor" item-value="valor"
                                        :items="lstTempoAtuacao" label="TEMPO DE ATUAÇÃO" return-object color="#007681"
                                        v-model="tempoAtuacao"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5">
                        <v-autocomplete item-text="valor" item-value="valor"
                                        :items="lstQtdFuncionarios" label="Nº DE FUNCIONÁRIOS DA CORRETORA" return-object
                                        color="#007681" v-model="numeroFuncionarios"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5">
                        <v-text-field label="MÉDIA DE PRÊMIO EMITIDO MENSAL"
                                      prefix="R$" color="#007681"
                                      v-model.lazy="mediaPremioEmitidoMensal" v-money="money"></v-text-field>
                    </v-col>

                    <v-col cols="12" class="mt-n1">
                        <h4>ESTADOS DE ATUAÇÃO</h4>
                    </v-col>

                    <v-container v-for="item in estadosAtuacao" :key="item.id" max-width="100%">
                        <v-row>
                            <v-col cols="12" sm="12" md="12" lg="12" class="mt-n5">
                                <v-autocomplete item-text="valor" item-value="valor"
                                                :items="lstEstados" label="SELECIONE UM ESTADO" return-object color="#007681"
                                                v-model="item.valor"></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                        <v-btn block color="#303030" @click="AdicionarEstado()" dark>ADICIONAR NOVO ESTADO</v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                    </v-col>

                    <v-col cols="12" sm="12" md="12" lg="12" class="mt-n5">
                        <template v-slot:label>
                            <div>Utiliza sistema de multicalculo e/ou gestão?</div>
                        </template>
                        <v-radio-group v-model="utilizaSistemaMulticalculo" row>
                            <template v-slot:label>
                                <div>Utiliza sistema de multicalculo e/ou gestão?</div>
                            </template>

                            <v-radio label="Sim" value="true"></v-radio>

                            <v-radio label="Não" value="false"></v-radio>

                        </v-radio-group>
                    </v-col>

                    <v-col cols="12" class="mt-n1" v-show="utilizaSistemaMulticalculo == [true]">
                        <h4>SISTEMAS UTILIZADOS</h4>
                    </v-col>

                    <v-container v-for="item in sistemaMulticalculo" :key="item.id" max-width="100%"
                                 v-show="utilizaSistemaMulticalculo == [true]">
                        <v-row>
                            <v-col cols="12" sm="12" md="12" lg="12" class="mt-n5">
                                <v-autocomplete item-text="valor" item-value="valor"
                                                :items="listSistemaMulticalculo" label="SELECIONE UM SISTEMA" return-object
                                                color="#007681" v-model="item.valor"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" lg="12" class="mt-n5" v-show="item.valor.valor == 'Outros'">
                                <v-text-field label="INSIRA AQUI O(S) SISTEMA(S) UTILIZADO(S)"
                                              color="#007681" v-model="item.valor.descricao"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center"
                           v-show="utilizaSistemaMulticalculo == [true]">
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center"
                           v-show="utilizaSistemaMulticalculo == [true]">
                        <v-btn block color="#303030" @click="AdicionarSistema()" dark>ADICIONAR NOVO SISTEMA</v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center"
                           v-show="utilizaSistemaMulticalculo == [true]">
                    </v-col>

                    <v-col cols="12" class="mt-n1">
                        <h4>PRINCIPAIS LINHAS DE PRODUTO</h4>
                    </v-col>

                    <v-container v-for="item in principaisLinhasProduto" :key="item.id" max-width="100%">
                        <v-row>
                            <v-col cols="12" sm="12" md="12" lg="12" class="mt-n5">
                                <v-autocomplete item-text="valor" item-value="valor"
                                                :items="linhasProduto" label="SELECIONE UMA LINHA DE PRODUTO" return-object
                                                color="#007681" v-model="item.valor"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" lg="12" class="mt-n5" v-show="item.valor.valor == 'Outros'">
                                <v-text-field label="INSIRA AQUI A(S) LINHAS(S) DE PRODUTO NÃO LISTADA(S)"
                                              color="#007681" v-model="item.valor.descricao"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                        <v-btn block color="#303030" @click="AdicionarLinhaProduto()" dark>
                            ADICIONAR NOVA LINHA DE
                            PRODUTO
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                    </v-col>

                    <!-- <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                        <v-file-input :rules="[rules.required]" v-model="arquivoContrato"
                            label="Contrato/Estatuto Social" id="arquivoContrato"
                            accept=".jpg, .jpeg, .png, .pdf, .doc, .docx" placeholder="Escolha seu arquivo"
                            prepend-icon="mdi-paperclip" variant="outlined" color="#007681" :show-size="1000">
                        </v-file-input>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                        <v-file-input :rules="[rules.required]" v-model="arquivoQuadroSocietario"
                            label="Quadro Societário" id="arquivoQuadroSocietario" accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                            placeholder="Escolha seu arquivo" prepend-icon="mdi-paperclip" variant="outlined"
                            color="#007681" :show-size="1000">
                        </v-file-input>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4" class="mt-n5 align-md-center">
                        <v-file-input :rules="[rules.required]" v-model="arquivoFaturamento"
                            label="Faturamento ou Último Balanço" id="arquivoFaturamento"
                            accept=".jpg, .jpeg, .png, .pdf, .doc, .docx" placeholder="Escolha seu arquivo"
                            color="#007681" prepend-icon="mdi-paperclip" variant="outlined" :show-size="1000">
                        </v-file-input>
                    </v-col> -->

                    <v-col cols="12" sm="12" md="4" lg="4" class=" align-md-center">
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class=" align-md-center">
                        <v-btn :loading="loadingBtn" block color="#303030" @click="AlterarPasso(2)" dark>
                            VOLTAR
                            ETAPA
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class=" align-md-center">
                        <v-btn :loading="loadingBtn" block color="#303030" @click="AlterarPasso(4)" dark>
                            PRÓXIMA
                            ETAPA
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class=" align-md-center">
                    </v-col>
                </v-row>

                <v-row id="etapa4" v-show="step == 4">
                    <v-col cols="12" class="mt-n1">
                        <h4>USÚARIO MASTER PORTAL</h4>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="6" class="mt-n5">
                        <v-text-field :rules="[rules.required]" :readonly="true" label="NOME" maxlength="75"
                                      color="#007681" v-model="nomeUsuario"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="6" class="mt-n5">
                        <v-text-field :rules="[rules.required, rules.email]" label="E-MAIL" maxlength="75"
                                      color="#007681" v-model="emailUsuario"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="6" class="mt-n8">
                        <v-text-field label="LOGIN(SUSEP)" :readonly="true" maxlength="75" color="#007681"
                                      v-model="login"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="6" class="mt-n8">
                        <v-text-field label="SENHA" :readonly="true" maxlength="75" color="#007681"
                                      v-model="senha"></v-text-field>
                    </v-col>


                    <v-col cols="12" v-if="false">
                        <v-card wi class="mx-auto" max-width="800">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title class="headline mb-1">Microseguros</v-list-item-title>
                                    <v-list-item-subtitle three-line class="wrap-text">

                                        <!-- O microsseguro é tido como o primeiro passo para englobar pessoas que nunca tiveram seguro.
                                        <br> Ou seja, seu alvo são consumidores de baixa renda... -->


                                    </v-list-item-subtitle>

                                </v-list-item-content>
                                <v-switch :readonly="true" v-model="microsseguros"></v-switch>
                            </v-list-item>
                        </v-card>
                    </v-col>

                    <v-col cols="12" v-if="false">
                        <v-card class="mx-auto" max-width="800">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title class="headline mb-1">
                                        Planos de
                                        Capitalização
                                    </v-list-item-title>
                                    <v-list-item-subtitle three-line class="wrap-text">

                                        <!-- texto texto texto texto texto texto texto texto texto texto                  -->

                                    </v-list-item-subtitle>

                                </v-list-item-content>
                                <v-switch :readonly="true" v-model="planosDeCapitalizacao"></v-switch>
                            </v-list-item>
                        </v-card>
                    </v-col>


                    <v-col cols="12" v-if="false">
                        <v-card class="mx-auto" max-width="800">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title class="headline mb-1">
                                        Planos de Previdência
                                        Complementar
                                    </v-list-item-title>
                                    <v-list-item-subtitle three-line class="wrap-text">

                                        <!-- texto texto texto texto texto texto texto texto texto texto                  -->

                                    </v-list-item-subtitle>

                                </v-list-item-content>
                                <v-switch :readonly="true" v-model="planosDePrevidenciaComplementar"></v-switch>
                            </v-list-item>
                        </v-card>
                    </v-col>

                    <v-col cols="12" v-if="false">
                        <v-card class="mx-auto" max-width="800">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title class="headline mb-1">Seguro de Danos</v-list-item-title>
                                    <v-list-item-subtitle three-line class="wrap-text">

                                        <!-- texto texto texto texto texto texto texto texto texto texto                  -->

                                    </v-list-item-subtitle>

                                </v-list-item-content>
                                <v-switch :readonly="true" v-model="seguroDeDano"></v-switch>
                            </v-list-item>
                        </v-card>
                    </v-col>
                    <v-col cols="12" v-if="false">
                        <v-card class="mx-auto" max-width="800">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title class="headline mb-1">Seguro de Pessoas</v-list-item-title>
                                    <v-list-item-subtitle three-line class="wrap-text">

                                        <!-- texto texto texto texto texto texto texto texto texto texto                  -->

                                    </v-list-item-subtitle>

                                </v-list-item-content>
                                <v-switch :readonly="true" v-model="seguroDePessoas"></v-switch>
                            </v-list-item>
                        </v-card>
                    </v-col>



                    <v-col cols="12" sm="12" md="4" lg="4" class=" align-md-center">
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class=" align-md-center">
                        <v-btn :loading="loadingBtn" block color="#303030" @click="AlterarPasso(3)" dark>
                            VOLTAR
                            ETAPA
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class=" align-md-center">
                        <v-btn :loading="loadingBtn" block color="#303030" @click="ConsultaScoreBureau(cnpj.replace('.', '').replace('/', '').replace('-', '').replace('.', ''), FinalizarCadastro)" dark>
                            FINALIZAR
                            CADASTRO
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" class=" align-md-center">
                    </v-col>

                </v-row>
            </v-card-text>
        </v-form>

        <v-dialog v-model="dialog" max-width="355" persistent>
            <v-card>
                <v-card-title class="headline" v-text="dialogTitle"></v-card-title>

                <v-card-text v-text="messageDialog">

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="#007681" v-if="dialogLink" text @click="dialogLink = false" href="https://ezzeseguros.com.br/fale-conosco.html">
                        Fale Conosco
                    </v-btn>

                    <v-btn color="#007681" text @click="dialog = false">
                        Fechar
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>

</template>

<script>
    import { mask } from 'vue-the-mask';
    // import Bancosjson from '../Bancos.json';
    import axios from 'axios';
    import { VMoney } from 'v-money'
    import moment from 'moment';

    export default
        {
            created() {
                this.GerarToken();
            },

            mounted() {
                this.BuscarBancos();
            },

            directives: { mask, money: VMoney },

            data: () => ({
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false /* doesn't work with directive */
                },
                assessoriaShow: false,
                possuiAssessoria: "",
                dialogTitle: "Oops",
                eventoLiberado: true,
                token: "",
                messageDialog: "",
                valid: true,
                dialog: false,
                dialogLink: false,
                contatos:
                    [{
                        id: 1,
                        nome: "",
                        email: "",
                        telefone: "",
                        cargo: ""
                    }],
                emailBoasVindas: "",
                loadingBtn: false,
                bancosjson: [],
                checkbox: false,
                microsseguros: false,
                planosDeCapitalizacao: false,
                planosDePrevidenciaComplementar: false,
                seguroDeDano: false,
                seguroDePessoas: false,
                cepCobranca: "",
                logradouroCobranca: "",
                numeroCobranca: "",
                complementoCobranca: "",
                bairroCobranca: "",
                cidadesCobranca: [],
                cidadeCobranca: "",
                bairro: "",
                numero: "",
                complemento: "",
                cnpj: "",
                numeroSusep: "",
                razaoSocial: "",
                cep: "",
                cidade: "",
                assessoria: "",
                logradouro: "",
                banco: "",
                agenciaDigito: "",
                contaDigito: "",
                enderecoPagamento: "",
                // nomeContato: "",
                email: "",
                nomeUsuario: "",
                emailUsuario: "",
                login: "",
                senha: "",
                step: 1,
                marker: true,
                msgSusep: "",
                msgSusepCorretoraLider: "",
                idPessoaI4pro: 0,
                loading: false,
                loadingCobranca: false,
                loadingAssessoria: false,
                assessoriaItem: [],
                loadingCnpj: false,
                loadingCnpjCorretorLider: false,
                items: [],
                search: null,
                searchCobranca: null,
                searchAssessoria: null,
                select: null,
                context: "",
                urlFrota:"",
                cidades: [],
                rules: {
                    required: value => !!value || 'Campo obrigatório.',
                    counter: value => value.length <= 20 || 'Max 20 characters',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'e-mail invalido.'
                    },
                    validarCnpj: value => {

                        const { cnpj } = require('cpf-cnpj-validator');

                        return value.length < 18 || cnpj.isValid(value) || "CNPJ invalido";

                    }

                },
                possuiGrupoCorretor: "",
                corretorLider: false,
                cnpjCorretorLider: "",
                razaoSocialCorretorLider: "",
                tempoAtuacao: "",
                lstTempoAtuacao: [
                    { id: 1, valor: "0 a 2 anos" },
                    { id: 2, valor: "3 a 5 anos" },
                    { id: 3, valor: "6 a 10 anos" },
                    { id: 4, valor: "Mais de 10 anos" },
                ],
                estadosAtuacao: [
                    {
                        id: 1,
                        valor: ""
                    }
                ],
                lstEstados: [
                    { id: 27, valor: "Acre" },
                    { id: 8, valor: "Alagoas" },
                    { id: 25, valor: "Amapá" },
                    { id: 10, valor: "Amazonas" },
                    { id: 13, valor: "Bahia" },
                    { id: 16, valor: "Ceará" },
                    { id: 15, valor: "Distrito Federal" },
                    { id: 21, valor: "Espírito Santo" },
                    { id: 22, valor: "Goiás" },
                    { id: 4, valor: "Maranhão" },
                    { id: 24, valor: "Mato Grosso" },
                    { id: 3, valor: "Mato Grosso do Sul" },
                    { id: 17, valor: "Minas Gerais" },
                    { id: 20, valor: "Pará" },
                    { id: 18, valor: "Paraíba" },
                    { id: 19, valor: "Paraná" },
                    { id: 14, valor: "Pernambuco" },
                    { id: 12, valor: "Piauí" },
                    { id: 12, valor: "Piauí" },
                    { id: 2, valor: "Rio de Janeiro" },
                    { id: 7, valor: "Rio Grande do Norte" },
                    { id: 23, valor: "Rio Grande do Sul" },
                    { id: 6, valor: "Rondônia" },
                    { id: 26, valor: "Roraima" },
                    { id: 11, valor: "Santa Catarina" },
                    { id: 9, valor: "Sergipe" },
                    { id: 1, valor: "São Paulo" },
                    { id: 5, valor: "Tocantins" },
                ],
                mediaPremioEmitidoMensal: null,
                linhasProduto: [
                    { id: 1, valor: "Auto Individual", descricao: "" },
                    { id: 2, valor: "Auto Frota", descricao: "" },
                    { id: 3, valor: "Transportes", descricao: "" },
                    { id: 4, valor: "Garantia", descricao: "" },
                    { id: 5, valor: "Linhas Financeiras", descricao: "" },
                    { id: 6, valor: "Responsabilidades", descricao: "" },
                    { id: 7, valor: "Property", descricao: "" },
                    { id: 8, valor: "Equipamentos", descricao: "" },
                    { id: 9, valor: "Engenharia", descricao: "" },
                    { id: 10, valor: "Vida", descricao: "" },
                    { id: 11, valor: "Saúde", descricao: "" },
                    { id: 12, valor: "Residencial", descricao: "" },
                    { id: 13, valor: "Condomínio", descricao: "" },
                    { id: 14, valor: "Agro", descricao: "" },
                    { id: 15, valor: "Náutico", descricao: "" },
                    { id: 16, valor: "Previdência", descricao: "" },
                    { id: 17, valor: "Outros", descricao: "" },
                ],
                principaisLinhasProduto: [
                    { id: 1, valor: "" }
                ],
                numeroFuncionarios: "",
                lstQtdFuncionarios: [
                    { id: 1, valor: "Nenhum" },
                    { id: 2, valor: "1 a 10" },
                    { id: 3, valor: "11 a 50" },
                    { id: 4, valor: "51 a 100" },
                    { id: 5, valor: "101 a 250" },
                    { id: 6, valor: "251 a 500" },
                    { id: 7, valor: "Mais de 500" },
                ],
                utilizaSistemaMulticalculo: "",
                sistemaMulticalculo: [
                    { id: 1, valor: "" }
                ],
                listSistemaMulticalculo: [
                    { id: 1, valor: "Agger", descricao: "" },
                    { id: 2, valor: "Corretagem Fácil", descricao: "" },
                    { id: 3, valor: "Quiver", descricao: "" },
                    { id: 4, valor: "Infocap", descricao: "" },
                    { id: 5, valor: "Segfy", descricao: "" },
                    { id: 6, valor: "Moshe", descricao: "" },
                    { id: 7, valor: "Teleport (Tex)", descricao: "" },
                    { id: 8, valor: "Outros", descricao: "" },
                ],
                /*arquivoContrato: null,
                arquivoQuadroSocietario: null,
                arquivoFaturamento: null,
                arquivoContrato64: "",
                arquivoQuadroSocietario64: "",
                arquivoFaturamento64: "",
                arquivoContratoNome: "",
                arquivoQuadroSocietarioNome: "",
                arquivoFaturamentoNome: "",*/
            }),
            watch:
            {
                search(val) {
                    val && val !== this.select && this.querySelections(val)
                },
                searchCobranca(val) {
                    val && val !== this.select && this.querySelectionsSearchCobranca(val)
                },
                searchAssessoria(val) {
                    val && val !== this.select && this.selectionsSearchAssessoria(val)
                },
                /*arquivoContrato: function (newVal, oldVal) {
                    if (newVal) {
                        this.createBase64Image(newVal, 1);
                        this.arquivoContratoNome = newVal.name;
                    } else {
                        this.arquivoContrato64 = null;
                    }
                },
                arquivoQuadroSocietario: function (newVal, oldVal) {
                    if (newVal) {
                        this.createBase64Image(newVal, 2);
                        this.arquivoQuadroSocietarioNome = newVal.name;
                    } else {
                        this.arquivoQuadroSocietario64 = null;
                    }
                },
                arquivoFaturamento: function (newVal, oldVal) {
                    if (newVal) {
                        this.createBase64Image(newVal, 3);
                        this.arquivoFaturamentoNome = newVal.name;
                    } else {
                        this.arquivoFaturamento64 = null;
                    }
                }*/
            },
            created(){
                this.context = process.env.VUE_APP_URL_EZZE_GATEWAY
                this.urlFrota = process.env.VUE_APP_URL_FROTA
            },
            methods:
            {
                // createBase64Image: function (FileObject, field) {
                //     const reader = new FileReader();
                //     reader.onload = (event) => {
                //         switch (field){
                //             case 1: {
                //                 this.arquivoContrato64 = event.target.result;
                //                 break;
                //             }
                //             case 2: {
                //                 this.arquivoQuadroSocietario64 = event.target.result;
                //                 break;
                //             }
                //             case 3: {
                //                 this.arquivoFaturamento64 = event.target.result;
                //                 break;
                //             }
                //         }
                //     }
                //     reader.readAsDataURL(FileObject);
                // },
                AlterarPasso: function (etapa) {
                    this.step = etapa;
                },
                AdicionarContato: function () {
                    // this.EnviarEmailBoasVindas();
                    this.GerarToken();
                    if (this.contatos.length < 5) {

                        var contato = { id: this.contatos.length + 1, nome: "", email: "", telefone: "", cargo: "" }
                        this.contatos.push(contato);
                    }

                },
                AdicionarEstado: function () {
                    this.GerarToken();
                    var estado = { id: this.estadosAtuacao.length + 1, valor: "" };
                    this.estadosAtuacao.push(estado);
                },
                AdicionarSistema: function () {
                    this.GerarToken();
                    var sistema = { id: this.sistemaMulticalculo.length + 1, valor: "" };
                    this.sistemaMulticalculo.push(sistema);
                },
                AdicionarLinhaProduto: function () {
                    this.GerarToken();
                    var linha = { id: this.principaisLinhasProduto.length + 1, valor: "" };
                    this.principaisLinhasProduto.push(linha);
                },
                BuscarCep: async function () {


                    if (this.cep.length == 9 && this.eventoLiberado) {
                        this.eventoLiberado = false;



                        if (this.token == "") {

                            await this.GerarToken();
                        }


                        var config =
                        {
                            method: 'get',
                            url: this.context + 'CEP/' + this.cep.replace('-', ''),
                            headers:
                            {
                                'Authorization': 'Bearer ' + this.token
                            }
                        };



                        axios(config)
                            .then(response => {

                                this.logradouro = response.data.objetoRetorno.logradouro;
                                this.bairro = response.data.objetoRetorno.nomeBairro;

                                var config =
                                {
                                    method: 'get',
                                    url: this.context + 'ConsultaCidade/' + response.data.objetoRetorno.nomeCidade,
                                    headers:
                                    {
                                        'Authorization': 'Bearer ' + this.token
                                    }
                                };

                                axios(config)
                                    .then(response2 => {

                                        this.cidades = response2.data.objetoRetorno.filter(function (cidade) {
                                            return cidade.nomeCidade == response.data.objetoRetorno.nomeCidade.toUpperCase() + "-" + response.data.objetoRetorno.uf.toUpperCase()
                                        })

                                        this.cidadesCobranca = this.cidades;

                                        this.cidade = this.cidades[0];
                                        this.eventoLiberado = true;

                                    })
                                    .catch(error => {
                                        console.log(error);
                                        this.eventoLiberado = true;
                                        if (error.response.status == 401) {
                                            this.GerarToken();

                                        }

                                    });



                            })
                            .catch(error => {
                                console.log(error);
                                this.eventoLiberado = true;
                                if (error.response.status == 401) {
                                    this.GerarToken();

                                }

                            });


                        //this.AlterarPasso();
                    }


                },
                BuscarCepCobranca: async function () {


                    if (this.cepCobranca.length == 9 && this.eventoLiberado) {
                        this.eventoLiberado = false;

                        if (this.token == "") {
                            await this.GerarToken();
                        }

                        var config =
                        {
                            method: 'get',
                            url: this.context + 'CEP/' + this.cepCobranca.replace('-', ''),
                            headers:
                            {
                                'Authorization': 'Bearer ' + this.token
                            }
                        };

                        axios(config)
                            .then(response => {

                                this.logradouroCobranca = response.data.objetoRetorno.logradouro;
                                this.bairroCobranca = response.data.objetoRetorno.nomeBairro;

                                var config =
                                {
                                    method: 'get',
                                    url: this.context + 'ConsultaCidade/' + response.data.objetoRetorno.nomeCidade,
                                    headers:
                                    {
                                        'Authorization': 'Bearer ' + this.token
                                    }
                                };

                                axios(config)
                                    .then(response2 => {


                                        this.cidadesCobranca = response2.data.objetoRetorno.filter(function (cidade) {

                                            return cidade.nomeCidade == response.data.objetoRetorno.nomeCidade.toUpperCase() + "-" + response.data.objetoRetorno.uf.toUpperCase()
                                        })

                                        this.cidadeCobranca = this.cidadesCobranca[0];
                                        this.eventoLiberado = true;

                                    })
                                    .catch(error => {
                                        this.eventoLiberado = true;
                                        if (error.response.status == 401) {

                                            this.GerarToken();

                                        }

                                    });



                            })
                            .catch(error => {
                                this.eventoLiberado = true;
                                if (error.response.status == 401) {

                                    this.GerarToken();

                                }

                            });



                        //this.AlterarPasso();
                    }

                },
                BuscarBancos: async function () {

                    if (this.token == "") {

                        await this.GerarToken();
                    }

                    var config =
                    {
                        method: 'get',
                        url: this.context + 'ConsultaBanco',
                        headers:
                        {
                            'Authorization': 'Bearer ' + this.token
                        }
                    };

                    axios(config)
                        .then(response => {
                            this.bancosjson = response.data.Result.Banco;
                        })
                        .catch(error => {
                            if (error.response.status == 401) {
                                this.GerarToken();
                            }
                        });
                },
                querySelections(v) {
                    if (v.length > 2) {

                        this.loading = true

                        setTimeout(() => {


                            var config =
                            {
                                method: 'get',
                                url: this.context + 'ConsultaCidade/' + v,
                                headers:
                                {
                                    'Authorization': 'Bearer ' + this.token
                                }
                            };


                            axios(config)
                                .then(response => {

                                    this.cidades = response.data.objetoRetorno
                                    this.cidadesCobranca = response.data.objetoRetorno
                                    this.loading = false

                                })
                                .catch(error => {
                                    if (error.response.status == 401) {

                                        this.GerarToken();

                                    }

                                });

                        }, 500)

                    }

                },
                querySelectionsSearchCobranca(v) {

                    if (v.length > 2) {

                        this.loadingCobranca = true


                        setTimeout(() => {


                            var config =
                            {
                                method: 'get',
                                url: this.context + 'ConsultaCidade/' + v,
                                headers:
                                {
                                    'Authorization': 'Bearer ' + this.token
                                }
                            };


                            axios(config)
                                .then(response => {

                                    this.cidadesCobranca = response.data.objetoRetorno
                                    this.loadingCobranca = false

                                    this.razaoSocial = data.data.retorno.registros[0].nome;
                                    this.numeroSusep = data.data.retorno.registros[0].protocolo;
                                    this.statusSusep = data.data.retorno.registros[0].situacao;
                                    this.nomeUsuario = data.data.retorno.registros[0].nome;
                                    this.login = data.data.retorno.registros[0].protocolo;
                                    this.senha = data.data.retorno.registros[0].protocolo;

                                    if (data.data.retorno.registros[0].produtos != null) {
                                        var produtos = data.data.retorno.registros[0].produtos.split(",").map(item => item.trim());
                                        this.microsseguros = produtos.indexOf("Microsseguros") > -1 ? true : false;
                                        this.planosDeCapitalizacao = produtos.indexOf("Planos de Capitalização") > -1 ? true : false;
                                        this.planosDePrevidenciaComplementar = produtos.indexOf("Planos de Previdência Complementar") > -1 ? true : false;
                                        this.seguroDeDano = produtos.indexOf("Seguros de Danos") > -1 ? true : false;
                                        this.seguroDePessoas = produtos.indexOf("Seguros de Pessoas") > -1 ? true : false;
                                    }

                                })
                                .catch(error => {
                                    if (error.response.status == 401) {
                                        this.GerarToken();

                                    }

                                });

                        }, 500)




                    }

                },
                selectionsSearchAssessoria(v) {

                    if (v.length > 2) {

                        this.loadingAssessoria = true


                        setTimeout(() => {


                            var config =
                            {
                                method: 'get',
                                url: this.context + 'ConsultaAssessoria?nome=' + v,
                                headers:
                                {
                                    'Authorization': 'Bearer ' + this.token
                                }
                            };


                            axios(config)
                                .then(response => {

                                    if (response.data.Result.objeto.pessoas != null) {
                                        this.assessoriaItem = response.data.Result.objeto.pessoas
                                    }


                                    this.loadingAssessoria = false

                                })
                                .catch(error => {
                                    if (error.response.status == 401) {
                                        this.GerarToken();
                                        this.loadingAssessoria = false;

                                    }

                                });

                        }, 500)




                    }

                },
                PesquisarCNPJCorretoraLider: async function () {
                    this.razaoSocialCorretorLider = "";

                    if (this.cnpjCorretorLider.length < 18) {
                        this.cnpjCorretorLider = "";
                    }

                    const { cnpj } = require('cpf-cnpj-validator');

                    if (cnpj.isValid(this.cnpjCorretorLider)) {
                        this.loadingCnpjCorretorLider = true;

                        var cnpjPesquisa = this.cnpjCorretorLider.replace(/\D/g, '');
                        var config =
                        {
                            method: 'get',
                            url: `${this.context}ConsultaCorretorSusep/${cnpjPesquisa}`,
                            headers:
                            {
                                'Authorization': 'Bearer ' + this.token
                            }
                        };

                        axios(config)
                        .then(({data}) => {

                                var retorno = data.Result
                                if (retorno.registros == undefined || retorno.registros.length == 0) {
                                    this.msgSusepCorretoraLider = "CNPJ não cadastrado na susep";
                                } else {
                                    this.razaoSocialCorretorLider = retorno.registros[0].nome;
                                    this.statusSusep = retorno.registros[0].situacao;
                                }

                                if (this.statusSusep != "Ativo" && this.msgSusepCorretoraLider == "") {
                                    this.msgSusepCorretoraLider = "O CNPJ inserido está associado a uma SUSEP suspensa, por isso não é possível prosseguir com o cadastro. Por gentileza, utilize um CNPJ válido e ativo para continuar.";
                                }

                                this.loadingCnpjCorretorLider = false; if (this.msgSusepCorretoraLider != "") {

                                    this.dialogTitle = "Atenção!";
                                    this.messageDialog = this.msgSusepCorretoraLider;
                                    this.dialog = true;

                                    this.cnpjCorretorLider = "";
                                    this.razaoSocialCorretorLider = "";
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                },
                PesquisarCNPJ: async function () {

                    this.razaoSocial = "";
                    this.numeroSusep = "";
                    this.msgSusep = "";
                    this.login = "";
                    this.senha = "";
                    this.microsseguros = false;
                    this.planosDeCapitalizacao = false;
                    this.planosDePrevidenciaComplementar = false;
                    this.seguroDeDano = false;
                    this.seguroDePessoas = false;

                    if (this.cnpj.length < 18) {
                        this.cnpj = "";
                    }

                    const { cnpj } = require('cpf-cnpj-validator');

                    if (cnpj.isValid(this.cnpj)) {

                        this.loadingCnpj = true

                        var cnpjPesquisa = this.cnpj.replace(/\D/g, '');

                        var config =
                        {
                            method: 'get',
                            url: `${this.context}ConsultaCorretorSusep/${cnpjPesquisa}`,
                            headers:
                            {
                                'Authorization': 'Bearer ' + this.token
                            }
                        };
console.log('URL context', config.url);
                        axios(config)
                            .then(({data}) => {

                                var retorno = data.Result
                                if (retorno.registros == undefined || retorno.registros.length == 0) {
                                    this.msgSusep = "CNPJ não cadastrado na susep";

                                } else {

                                    this.razaoSocial = retorno.registros[0].nome;
                                    this.numeroSusep = retorno.registros[0].protocolo;
                                    this.statusSusep = retorno.registros[0].situacao;
                                    this.nomeUsuario = retorno.registros[0].nome;
                                    this.login = retorno.registros[0].protocolo;
                                    this.senha = retorno.registros[0].protocolo;

                                    if (retorno.registros[0].produtos != null) {
                                        var produtos = retorno.registros[0].produtos.split(",").map(item => item.trim());
                                        this.microsseguros = produtos.indexOf("Microsseguros") > -1 ? true : false;
                                        this.planosDeCapitalizacao = produtos.indexOf("Planos de Capitalização") > -1 ? true : false;
                                        this.planosDePrevidenciaComplementar = produtos.indexOf("Planos de Previdência Complementar") > -1 ? true : false;
                                        this.seguroDeDano = produtos.indexOf("Seguros de Danos") > -1 ? true : false;
                                        this.seguroDePessoas = produtos.indexOf("Seguros de Pessoas") > -1 ? true : false;
                                    }
                                }

                                if (this.statusSusep != "Ativo" && this.msgSusep == "") {
                                    this.msgSusep = "O CNPJ inserido está associado a uma SUSEP suspensa, por isso não é possível prosseguir com o cadastro. Por gentileza, utilize um CNPJ válido e ativo para continuar.";
                                }

                                this.loadingCnpj = false;

                                if (this.msgSusep != "") {

                                    this.dialogTitle = "Atenção!";
                                    this.messageDialog = this.msgSusep;
                                    this.dialog = true;

                                    this.cnpj = "";

                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }

                },

                PossuiAssessoria: function () {

                    if (this.possuiAssessoria == "true") {
                        this.assessoriaShow = true;

                    } else {
                        this.assessoriaShow = false;
                        this.assessoria = "";
                    }


                },
                UtilizarMesmoEndereco: function () {


                    if (this.checkbox) {
                        this.cepCobranca = this.cep;
                        this.logradouroCobranca = this.logradouro;
                        this.numeroCobranca = this.numero;
                        this.complementoCobranca = this.complemento;
                        this.bairroCobranca = this.bairro;
                        this.cidadeCobranca = this.cidade;
                        this.cidadesCobranca = this.cidades;

                    } else {

                        this.cepCobranca = "";
                        this.logradouroCobranca = "";
                        this.numeroCobranca = "";
                        this.complementoCobranca = "";
                        this.bairroCobranca = "";
                        this.cidadeCobranca = "";
                    }

                },
                FinalizarCadastro: function (ativo = true) {

                    if (this.$refs.form.validate()) {

                        this.loadingBtn = true;

                        var ufCidade = this.cidade.nomeCidade.substring(this.cidade.nomeCidade.lastIndexOf("-") + 1, this.cidade.nomeCidade.length);
                        var nomeCidade = this.cidade.nomeCidade.substring(0, this.cidade.nomeCidade.lastIndexOf("-"));

                        var ufCidadeCobranca = this.cidade.nomeCidade.substring(this.cidade.nomeCidade.lastIndexOf("-") + 1, this.cidade.nomeCidade.length);
                        var nomeCidadeCobranca = this.cidade.nomeCidade.substring(0, this.cidade.nomeCidade.lastIndexOf("-"));

                        var listaEstados = [];
                        this.estadosAtuacao.forEach(e => {
                            listaEstados.push(e.valor);
                        })

                        var listaLinhas = [];
                        this.principaisLinhasProduto.forEach(e => {
                            listaLinhas.push(e.valor);
                        })

                        var listaSistemas = [];
                        this.sistemaMulticalculo.forEach(e => {
                            listaSistemas.push(e.valor);
                        })

                        var jsonEnvioi4pro = JSON.stringify(
                            {

                                "cpfCnpj": this.cnpj,
                                "nrSusep": this.numeroSusep,
                                "razaoSocial": this.razaoSocial,
                                "idAssessoria": this.assessoria.id_pessoa == null ? 0 : this.assessoria.id_pessoa,
                                "cep": this.cep,
                                "uf": ufCidade,
                                "CdUf": this.cidade.idEstado,
                                "cidade": nomeCidade,
                                "endereco": this.logradouro,
                                "nrBanco": this.banco.nr_banco,
                                "agenciaDigito": this.agenciaDigito,
                                "contaDigito": this.contaDigito,
                                "logradouro": this.logradouro,
                                "numeroEndereco": this.numero,
                                "bairro": this.bairro,
                                "complemento": this.complemento,
                                "cepCobranca": this.cepCobranca,
                                "ufCobranca": ufCidadeCobranca,
                                "CdUfCobranca": this.cidade.idEstado,
                                "cidadeCobranca": nomeCidadeCobranca,
                                "logradouroCobranca": this.logradouroCobranca,
                                "numeroEnderecoCobranca": this.numeroCobranca,
                                "bairroCobranca": this.bairroCobranca,
                                "complementoCobranca": this.complementoCobranca,
                                "contatos": this.contatos,
                                "nome": this.razaoSocial,
                                "email": this.emailUsuario,
                                "login": this.numeroSusep,
                                "senha": this.numeroSusep,
                                "possuiGrupoCorretor": this.possuiGrupoCorretor == '' ? null : this.possuiGrupoCorretor,
                                "corretorLider": this.possuiGrupoCorretor == true ? this.corretorLider == '' ? null : this.corretorLider : null,
                                "cnpjCorretorLider": this.cnpjCorretorLider,
                                "razaoSocialCorretorLider": this.razaoSocialCorretorLider,
                                "tempoAtuacao": this.tempoAtuacao.valor,
                                "estadosAtuacao": listaEstados,
                                "mediaPremioEmitidoMensal": Number(this.mediaPremioEmitidoMensal.replaceAll('.', '').replace(',', '.')),
                                "principaisLinhasProduto": listaLinhas,
                                "numeroFuncionarios": this.numeroFuncionarios.valor,
                                "utilizaSistemaMulticalculo": this.utilizaSistemaMulticalculo == '' ? null : this.utilizaSistemaMulticalculo,
                                "sistemaMulticalculo": listaSistemas,
                                "BloqueiaCadastro": !ativo,
                                // "arquivoContrato": this.arquivoContrato64,
                                // "arquivoFaturamento": this.arquivoFaturamento64,
                                // "arquivoQuadroSocietario": this.arquivoQuadroSocietario64,
                                // "arquivoContratoNome": this.arquivoContratoNome,
                                // "arquivoFaturamentoNome": this.arquivoFaturamentoNome,
                                // "arquivoQuadroSocietarioNome": this.arquivoQuadroSocietarioNome,
                            });
                        console.log(jsonEnvioi4pro);
                        var config =
                        {
                            method: 'post',
                            url: this.context + 'InserirCorretorI4pro',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.token
                            },
                            data: jsonEnvioi4pro
                        };



                        axios(config)
                            .then((response) => {

                                if (response.data.Result.isOk && response.data.Result.mensagem != "" && !isNaN(response.data.Result.mensagem) && parseInt(response.data.Result.mensagem) > 0) {


                                    this.idPessoaI4pro = parseInt(response.data.Result.mensagem);

                                    if (this.idPessoaI4pro > 0) {
                                        // var cnpj = this.cnpj.replace('.', '').replace('/', '').replace('-', '').replace('.', '');
                                        // this.ConsultaScoreBureau(cnpj, this.CadastrarUsuarioPortal);
                                        this.CadastrarUsuarioPortal(ativo);
                                    }


                                } else {
                                    this.loadingBtn = false;
                                    this.dialogTitle = "Oops";
                                    this.messageDialog = response.data.Result.mensagem;
                                    this.dialog = true;

                                }

                            })
                            .catch((error) => {

                                console.log(error);
                                this.loadingBtn = false;

                                this.dialogTitle = "Oops";
                                this.messageDialog = 'Erro ao efetuar cadastro.';
                                this.dialog = true;



                            });

                    } else {

                        this.dialogTitle = "Oops";
                        this.messageDialog = 'Favor verificar os campos destacados em vermelho.';
                        this.dialog = true;
                        this.step = 1;
                    }

                },
                ConsultaScoreBureau: function (cnpj, callback) {
                    var config = {
                        method: 'get',
                        url: `${this.urlFrota}/${cnpj}`,
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token

                        }
                    };

                    axios(config)
                        .then((response) => {
                            var score = (response?.data?.optionalFeatures?.score?.score ?? "0");
                            var companyFoundation = (response?.data?.reports[0]?.identificationReport?.companyFoundation);
                            var dataFundacaoAgora = moment().diff(moment(companyFoundation), 'years', true);

                            callback(score > 300 && dataFundacaoAgora > 1)
                        })
                        .catch(function (error) {
                            console.log(error);
                            callback(false)
                        });
                },
                CadastrarUsuarioPortal: function (ativo = true) {

                    var title = ativo ? "Bem vindo a Ezze Seguros!" : "Recebemos sua solicitação de cadastro";
                    var msg = "Seu cadastro foi realizado e será avaliado internamente. Qualquer dúvida, favor entrar em contato através do Fale Conosco em nosso site.";
                    var data = JSON.stringify(
                        {
                            "nmUsuario": this.numeroSusep,
                            "senha": this.numeroSusep,
                            "nome": this.razaoSocial,
                            "idPessoaI4pro": this.idPessoaI4pro,
                            "ativo": ativo,
                            "trocarSenha": ativo,
                            "idPerfil": 3,
                            "email": this.emailUsuario,
                            "usuarioPerfil":
                                [
                                    {
                                        "idPerfil": 3
                                    }
                                ]
                        });


                    var config = {
                        method: 'post',
                        url: this.context + 'InserirUsuario',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token

                        },
                        data: data
                    };


                    axios(config)
                        .then((response) => {

                            this.dialogTitle = title;
                            this.EnviarEmailBoasVindas(ativo);

                            if (response.data.isOk) {
                                var mensagem = ativo ? "Seu cadastro foi realizado. Em breve, você receberá as informações de acesso por e-mail. Se precisar de qualquer ajuda, fale com a gente através do nosso site." : "Seu cadastro foi realizado e será avaliado internamente. Por favor, aguarde.";
                                this.dialogLink = false;
                                this.messageDialog = mensagem;
                            }
                            else {
                                this.messageDialog = msg;
                                this.dialogLink = true;
                                //this.EnviarEmailCadastroIncompleto(ativo);
                            }

                            this.dialog = true;
                            this.loadingBtn = false;
                        })
                        .catch((error) => {
                            console.log(error);
                            this.loadingBtn = false;

                            this.dialogTitle = title;
                            this.messageDialog = msg;
                            this.dialog = true;
                            this.dialogLink = true;
                            //this.EnviarEmailCadastroIncompleto(ativo);
                        });
                },
                EnviarEmailBoasVindas: async function (ativo) {


                    if (ativo) {
                        await axios.get("./EmailBoasVindas.html").then(response => {
                            this.emailBoasVindas = response.data;
                        })
                    }
                    else {
                        await axios.get("./EmailBoasVindasInativo.html").then(response => {
                            this.emailBoasVindas = response.data;
                        })
                    }
                    this.emailBoasVindas = this.emailBoasVindas.replace(/##NOME##/g, this.razaoSocial);

                    var assunto = ativo ? "Sucesso! Você agora é um parceiro Ezze Seguros." : "Sobre seu pedido de cadastro na EZZE Seguros";
                    var data = JSON.stringify(
                        {
                            "nomeRemetente": "EZZE Seguros",
                            "emailRemetente": "nao.responda@ezzeseguros.com.br",
                            "destinatarios": [this.emailUsuario],
                            "assunto": assunto,
                            "corpo": this.emailBoasVindas,
                            "copias": ["cadastro.comercial@ezzeseguros.com.br"],
                            "isBodyHtml": true,
                            "useDefaultCredentials": true
                        });

                    var config = {
                        method: 'post',
                        url: this.context + 'EnvioEmail',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                        data: data
                    };

                    axios(config)
                        .then(function (response) {
                            //console.log(response);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });


                },
                EnviarEmailCadastroIncompleto: async function (ativo) {

                    var json = JSON.stringify({
                        "nmUsuario": this.numeroSusep,
                        "senha": this.numeroSusep,
                        "nome": this.razaoSocial,
                        "idPessoaI4pro": this.idPessoaI4pro,
                        "ativo": ativo,
                        "trocarSenha": ativo,
                        "idPerfil": 3,
                        "email": this.emailUsuario,
                        "usuarioPerfil":
                            [
                                {
                                    "idPerfil": 3
                                }
                            ]
                    });
                    this.emailBoasVindas = "O cadastro no portal para o corretor [" + this.razaoSocial + "] não foi realizado.</br></br>" +
                        "JSON do post: </br></br>" + json.replaceAll('\"', '\'');

                    var data = JSON.stringify(
                        {
                            "nomeRemetente": "EZZE Seguros",
                            "emailRemetente": "nao.responda@ezzeseguros.com.br",
                            "destinatarios": ["suporte.ti@ezzeseguros.com.br"],
                            "assunto": "Cadastro corretor [" + this.razaoSocial + "] incompleto",
                            "corpo": this.emailBoasVindas,
                            "isBodyHtml": true,
                            "useDefaultCredentials": true
                        });

                    var config = {
                        method: 'post',
                        url: this.context + 'EnvioEmail',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                        data: data
                    };

                    axios(config)
                        .then(function (response) {
                            //console.log(response);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });


                },
                GerarToken: async function () {

                    var qs = require('qs');
                    var data = qs.stringify({
                        'grant_type': 'password'
                    });



                    var config =
                    {
                        method: 'post',
                        url: this.context + 'token',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        data: data
                    };



                    await axios(config)
                        .then(response => {
                            this.token = response.data.objetoRetorno.access_token;

                        })
                        .catch(function (error) {
                            console.log(error);
                        });

                },
            }
        }
</script>

<style scoped>
    .labelTitulo {
        text-align: left;
        margin-left: -5px;
    }

    .wrap-text {
        -webkit-line-clamp: unset !important;
    }

    .v-stepper {
        top: 0;
        width: 100%;
        background-color: rgba(255, 255, 255, 1);
    }


    .container {
        max-width: 100%;
    }
</style>